import { useEffect, useRef, memo } from 'react';

// Free TradingView ticker tape widget – no API key required, real-time prices
function TradingViewTicker() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    // Clear previous script
    containerRef.current.innerHTML = '<div class="tradingview-widget-container__widget"></div>';
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;
    script.type = 'text/javascript';
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: 'OANDA:XCUUSD', title: 'Cuivre / Copper' },
        { proName: 'OANDA:XAUUSD', title: 'Or / Gold' },
        { proName: 'OANDA:XAGUSD', title: 'Argent / Silver' },
        { proName: 'TVC:USOIL', title: 'Pétrole WTI (bitume)' },
        { proName: 'OANDA:XPTUSD', title: 'Platine' },
        { proName: 'OANDA:XPDUSD', title: 'Palladium' },
        { proName: 'FX:EURUSD', title: 'EUR / USD' },
      ],
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: 'adaptive',
      colorTheme: 'dark',
      locale: 'fr',
    });
    containerRef.current.appendChild(script);
  }, []);

  return (
    <div className="tradingview-widget-container" ref={containerRef}>
      <div className="tradingview-widget-container__widget" />
    </div>
  );
}

export default memo(TradingViewTicker);
